function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { borderBottom } from 'styled-system';
import TextCell from './TextCell';
const StyledHeaderCell = styled(TextCell).withConfig({
  displayName: "HeaderCell__StyledHeaderCell",
  componentId: "sc-1qzvyu7-0"
})(["", ""], borderBottom);
const HeaderCell = /*#__PURE__*/React.memo(_ref => {
  let {
    label,
    style,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledHeaderCell, _extends({
    style: style
  }, props), label);
});
HeaderCell.propTypes = {
  label: PropTypes.node,
  style: PropTypes.object,
  title: PropTypes.string
};
HeaderCell.defaultProps = {
  bg: 'gray.2',
  borderBottom: 'bold',
  color: 'darkPrimary',
  fontWeight: 'bold'
};
HeaderCell.displayName = 'HeaderCell';
export default HeaderCell;